import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaUser, FaHome, FaWallet, FaBars, FaUserEdit, FaRobot } from 'react-icons/fa';
import { useSidebar } from '../context/SidebarContext';
import SetUsernameButton from './SetUsernameButton';
import LoginOptions from './LoginOptions';

const Header = () => {
  const { user, setShowUsernameModal } = useAuth();
  const { toggleSidebar } = useSidebar();

  return (
    <header className="fixed top-0 left-0 right-0 h-16 bg-dark-200/80 border-b border-violet-500/20 flex items-center justify-between px-6 z-50 md:hidden shadow-lg backdrop-blur-md">
      {/* Gradient effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-violet-600/5 to-purple-600/5 z-0"></div>

      {/* Logo */}
      <Link to="/" className="flex items-center relative z-10">
        <div className="relative">
          <div className="absolute -inset-1 bg-violet-500/10 rounded-full blur-md"></div>
          <img src="/logo.png" alt="BitSport" className="h-8 relative" />
        </div>
      </Link>

      {/* Navigation Icons */}
      <div className="flex items-center gap-6 relative z-10">
        <Link to="/" className="text-gray-300 hover:text-violet-400 transition-colors duration-300">
          <FaHome className="text-xl" />
        </Link>

        <Link to="/quests" className="text-gray-300 hover:text-violet-400 transition-colors duration-300">
          <FaRobot className="text-xl" />
        </Link>

        {user?.isConnected && (
          <>
            <Link
              to="/wallet"
              className="text-gray-300 hover:text-violet-400 transition-colors duration-300 relative group"
            >
              <FaWallet className="text-xl" />
              <span className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-violet-500 to-purple-500 group-hover:w-full transition-all duration-300"></span>
            </Link>

            <Link
              to={`/${user.address}`}
              className="text-gray-300 hover:text-violet-400 transition-colors duration-300 relative group"
            >
              <FaUser className="text-xl" />
              <span className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-violet-500 to-purple-500 group-hover:w-full transition-all duration-300"></span>
            </Link>

            <button
              onClick={() => setShowUsernameModal(true)}
              className="text-gray-300 hover:text-violet-400 transition-colors duration-300 relative group"
              title="Set Username"
            >
              <FaUserEdit className="text-xl" />
              <span className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-gradient-to-r from-violet-500 to-purple-500 group-hover:w-full transition-all duration-300"></span>
            </button>
          </>
        )}

        <div className="hidden md:block">
          <LoginOptions />
        </div>

        <button
          onClick={toggleSidebar}
          className="relative group p-2 rounded-lg bg-dark-300/80 border border-violet-500/20 text-gray-300 hover:text-violet-400 hover:border-violet-500/40 transition-all duration-300"
        >
          <FaBars className="text-xl" />
          <span className="absolute inset-0 rounded-lg bg-gradient-to-r from-violet-500/10 to-purple-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
